import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Schemas from "../../../utilities/validations";
import { useReduxStore } from "../../../hooks/useReduxStore";
import { LoginAction, RegisterAction, SendOtpAction, VerifyOtpAction } from "../../../store/Actions/action";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../../store/Reducers/authReducer";
import { CreateUserAction } from "../../../store/Actions/adminActions";
import { getPlans } from "../../../services/paymentService";
import { toast } from "react-toastify";
import { toastConfiguration } from "../../../Constant/Data";

export default function useCreateUser({ isModal, onClose,closeVerificationModal }) {
  const [formType, setFormType] = useState("login");
  const [showOtpForm, setShowOtpForm] = useState(false);
  const [otp, setOtp] = useState("");
  const [signupEmail, setSignupEmail] = useState("");
  const [otpError, setOtpError] = useState("");
  const [otpSuccess, setOtpSuccess] = useState("");
  const [resendLoading, setResendLoading] = useState(false);
  const [plans, setPlans] = useState([]);
  const [loadingPlans, setLoadingPlans] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("");

  const navigate = useNavigate();
  const { dispatch, getState } = useReduxStore();
  const { loginSuccess, registerSuccess, otpSent, otpVerified,OTPSuccess,token,userData } = getState("AUTH");
  let { route, goBack } = window?.history?.state?.usr || {};

 
  const {
    register: signupRegister,
    handleSubmit: signupHandleSubmit,
    formState: { errors: signupErrors },
    reset: resetRegister,
  } = useForm({
    resolver: Schemas.register,
  });

  useEffect(() => {
    if (isModal) {
      fetchPlans();
    }
  }, [isModal]);

  const fetchPlans = async () => {
    setLoadingPlans(true);
    try {
      const response = await getPlans();
      if (response.ok && response.data.success) {
        setPlans(response.data.plans);
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
    } finally {
      setLoadingPlans(false);
    }
  };



  const onSignup =async (data = {}) => {
    // console.log("slected plan ------------",selectedPlan);
    if(!selectedPlan){
      toast.info("Please select a plan",toastConfiguration);
    }
    else{
      const action=()=>{
      onClose()
    }
    dispatch(CreateUserAction({ ...data, planId: selectedPlan, action }));
    }
  };




 

 


  const onRegisterSuccess = () => {
    // resetRegister();
    // setFormType("login");
      setShowOtpForm(true);

  };

  // useEffect(() => {
  //   registerSuccess && onRegisterSuccess();
  // }, [registerSuccess]);
  // OTP send hone par OTP form dikhao

  return {
  
    signupHandleSubmit,
    signupRegister,
    onSignup,
    signupErrors,
    plans,
    loadingPlans,
    selectedPlan,
    setSelectedPlan,
  };
}

